import { render, staticRenderFns } from "./headerIndex.vue?vue&type=template&id=c457dee0&scoped=true&"
import script from "./headerIndex.vue?vue&type=script&lang=js&"
export * from "./headerIndex.vue?vue&type=script&lang=js&"
import style0 from "./headerIndex.vue?vue&type=style&index=0&id=c457dee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c457dee0",
  null
  
)

export default component.exports